import React from 'react';
import { MetricCard } from 'common/components';
import { STATUS_ICON_THEME, type CallStatusSummaryCard } from '../../callStatusSummary.utils';

export type CallStatusCardProps = {
    card: CallStatusSummaryCard;
    isSelected?: boolean;
    onClick?: (cardId: string) => void;
    /** When set, replaces the count / percent row (e.g. avg duration). */
    primaryValue?: string;
    showPercent?: boolean;
};

export const CallStatusCard: React.FC<CallStatusCardProps> = ({
    card,
    isSelected = false,
    onClick,
    primaryValue,
    showPercent = true,
}) => (
    <MetricCard
        id={card.id}
        label={card.label}
        tooltip={card.tooltip}
        theme={STATUS_ICON_THEME[card.variant]}
        count={card.count}
        percent={card.percent}
        primaryValue={primaryValue}
        showPercent={showPercent}
        isSelected={isSelected}
        onClick={onClick}
        testId={`call-status-card-${card.id}`}
        tabId={`call-status-tab-${card.id}`}
        panelId={`call-status-panel-${card.id}`}
    />
);